import './cardrow.css';
import IMAGES from '../../images/images';
import { archiData } from '../../data';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import SwiperCore, {
    Zoom,Pagination,Keyboard, Autoplay, EffectFade 
  } from 'swiper';

SwiperCore.use([Zoom,Pagination,Keyboard,Autoplay,EffectFade]);




export default function CardRow() {
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    
    useEffect(() => {
        const filteredData = archiData.filter((project) =>
        project.title.toLowerCase().includes(searchTerm.toLowerCase())
        );

        setProjects(filteredData);
    }, [searchTerm]);

    // console.log(projects);
    // console.log("debug>>",IMAGES.search_icon);

    // console.log("slideImg>>",archiData[3].slideImgs);

    return (
        <div className="cardSection">
            <div className="cardSection__titleWrapper">
                <h3 className="card__title">Featured Projects</h3>
                <div className="card__titleSearch">
                    <div className="card__input">
                        <img src={IMAGES.search_icon} alt="" />
                        <input type="text" placeholder="find project..." onChange={(e) => setSearchTerm(e.target.value)}/>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <>
                {projects.length ? projects.map((d) => (
                    // console.log("d>>", d),
                    <div className="cardWrapper">
                        <Link to={`/architecture/${d.id}`} className="cardWrapper">
                            <img src={d.cardImg} alt={d.title} id={d.id} />
                            <p>{d.title}</p>
                        </Link>
                    </div>
                )) : <p className="webApp__noResult">Oops,try again. There isn't such project...</p>}
                </>
            </div>
        </div>
    )
}

